import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Home from './components/Home';
import LegalPages from './components/LegalPages';
import SEO from './components/SEO';

// Page de maintenance temporaire
const MaintenancePage = () => {
  return (
    <div style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", sans-serif',
      background: 'linear-gradient(135deg, #8B4513 0%, #A0522D 50%, #CD853F 100%)',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      margin: 0,
      padding: 0
    }}>
      <div style={{
        textAlign: 'center',
        maxWidth: '600px',
        padding: '2rem',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '20px',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        border: '1px solid rgba(255, 255, 255, 0.2)'
      }}>
        <div style={{
          fontSize: '4rem',
          marginBottom: '1.5rem',
          animation: 'pulse 2s infinite'
        }}>🔧</div>
        
        <h1 style={{
          fontSize: '2.5rem',
          marginBottom: '1rem',
          fontWeight: '700'
        }}>Site en maintenance</h1>
        
        <p style={{
          fontSize: '1.2rem',
          marginBottom: '2rem',
          opacity: '0.9'
        }}>Angèle Rosalie - Sage-femme libérale à Annecy</p>
        
        <div style={{
          fontSize: '1.1rem',
          lineHeight: '1.6',
          marginBottom: '2rem',
          opacity: '0.8'
        }}>
          <p>Nous mettons à jour notre site pour vous offrir une meilleure expérience.</p>
          <p>Le site sera bientôt de nouveau accessible.</p>
        </div>
        
        <div style={{
          background: 'rgba(255, 255, 255, 0.1)',
          padding: '1.5rem',
          borderRadius: '15px',
          marginTop: '2rem'
        }}>
          <h3 style={{
            marginBottom: '1rem',
            fontSize: '1.3rem'
          }}>📞 Contact d'urgence</h3>
          
          <div style={{ marginBottom: '0.5rem', fontSize: '1rem' }}>
            <strong style={{ color: '#FFD700' }}>Téléphone :</strong> 06 21 30 68 56
          </div>
          
          <div style={{ marginBottom: '0.5rem', fontSize: '1rem' }}>
            <strong style={{ color: '#FFD700' }}>Email :</strong> contact@angele-sagefemme.fr
          </div>
          
          <div style={{ marginBottom: '0.5rem', fontSize: '1rem' }}>
            <strong style={{ color: '#FFD700' }}>Urgences :</strong> Hôpital d'Annecy - 04 50 63 63 63
          </div>
        </div>
        
        <div style={{
          marginTop: '2rem',
          fontSize: '0.9rem',
          opacity: '0.7'
        }}>
          <p>Merci de votre patience et de votre compréhension.</p>
          <p>À bientôt !</p>
        </div>
      </div>
      
      <style>{`
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }
        
        @media (max-width: 768px) {
          .maintenance-container {
            margin: 1rem;
            padding: 1.5rem;
          }
        }
      `}</style>
    </div>
  );
};

function App() {
  // Maintenance pilotée par la variable d'environnement REACT_APP_MAINTENANCE_MODE
  const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
  
  if (isMaintenanceMode) {
    return <MaintenancePage />;
  }
  
  return (
    <HelmetProvider>
      <div className="App">
        <SEO />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/mentions-legales" element={<LegalPages type="mentions" />} />
            <Route path="/politique-confidentialite" element={<LegalPages type="confidentialite" />} />
            <Route path="/cgu" element={<LegalPages type="cgu" />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
